import { clsx } from 'clsx';
import ReactModal from 'react-modal';

import { DecisionModalIcon, DecisionModalIconType } from './DecisionModalIcon';
import { ErrorModal } from './ErrorModal';
import { useModal } from '../../../store/ModalProvider';
import { buildQueryString } from '../../../utils/queryParams';
import { DecisionErrorTypes } from '../../ApprovalRequirements';
import { DecisionStatus, useDecision } from '../../DecisionProvider';

export const DECISION_MODAL_ID = 'decisionModal';

export const DecisionModal = () => {
  const { isOpen } = useModal(DECISION_MODAL_ID);
  const { decisionError, decisionStatus } = useDecision();

  const handleFatalError = () => {
    const queryString = buildQueryString();
    // eslint-disable-next-line react-hooks/immutability -- intentional navigation on fatal error
    window.location.href = `/pay/signup/error${queryString}`;
  };

  return (
    <ReactModal
      className={clsx(
        'absolute left-1/2 top-1/2 flex min-h-[288px] w-full -translate-x-1/2 -translate-y-1/2 flex-col rounded-s border border-secondary-80 bg-white p-l shadow-black-m outline-none',
        {
          'max-w-[450px]': decisionStatus === DecisionStatus.ERROR,
          'max-w-[301px]': decisionStatus !== DecisionStatus.ERROR,
        },
      )}
      overlayClassName="fixed z-[15] inset-0 bg-overlay-decision-modal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      {(() => {
        if (decisionStatus === DecisionStatus.APPROVED) {
          return (
            <>
              <DecisionModalIcon type={DecisionModalIconType.APPROVAL} />

              <p className="mb-l text-center text-xl font-bold text-success-drk">
                Approved
              </p>
              <p className="mb-l text-center text-m font-reg text-structure-40">
                Redirecting to overview...
              </p>
            </>
          );
        }

        if (decisionStatus === DecisionStatus.DECLINED) {
          return (
            <>
              <div className="flex flex-1 items-center text-center text-xl font-bold">
                Sorry, we can’t fund your application at this time
              </div>

              <p className="mb-l text-center text-m font-reg text-structure-40">
                Redirecting to overview...
              </p>
            </>
          );
        }

        if (
          decisionStatus === DecisionStatus.ERROR &&
          (decisionError ===
            DecisionErrorTypes.DIRECTORS_COMPANY_MISMATCH_ERROR ||
            decisionError === DecisionErrorTypes.INCOMPLETE_CREDIT_CHECK_ERROR)
        ) {
          return <ErrorModal />;
        } else if (
          decisionStatus === DecisionStatus.ERROR ||
          decisionStatus === DecisionStatus.UNKNOWN
        ) {
          handleFatalError();
        }

        let description = '';
        if (decisionStatus === DecisionStatus.CHECK_CREDIT_PROFILE) {
          description = 'Checking credit profile';
        }

        if (decisionStatus === DecisionStatus.SUBMITTING) {
          description = 'Submitting application';
        }
        return (
          <>
            <DecisionModalIcon type={DecisionModalIconType.LOADING} />

            <div className="flex grow items-center justify-center">
              <p className="mb-l text-center text-m font-reg text-structure-40">
                {description}
              </p>
            </div>
          </>
        );
      })()}
    </ReactModal>
  );
};
